import script from "./SeoHead.vue?vue&type=script&lang=js"
export * from "./SeoHead.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__